import { DCBaseWheelEvent } from "./DCBaseWheelEvent.js";
export class DCBaseWheelUpEvent extends DCBaseWheelEvent {
    eventType = "wheel-up";
    inputType = "mouse";
    constructor() {
        super();
    }
}
